import { createName } from 'store/utils';

import { FEATURE_NAME } from './consts';

const getName = createName(FEATURE_NAME);

export const FETCH_KPI_HISTORY = getName('FETCH_KPI_HISTORY');
export const FETCH_DASHBOARD_KPI = getName('FETCH_DASHBOARD_KPI');
export const EXPORT_DASHBOARD_EXCEL = getName('EXPORT_DASHBOARD_EXCEL');
